// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ServerSkipCooldownRolloutRequest
 */
export interface ServerSkipCooldownRolloutRequest {
  /**
   *
   * @type {number}
   * @memberof ServerSkipCooldownRolloutRequest
   */
  step?: number;
}

/**
 * Check if a given object implements the ServerSkipCooldownRolloutRequest interface.
 */
export function instanceOfServerSkipCooldownRolloutRequest(
  value: object,
): value is ServerSkipCooldownRolloutRequest {
  return true;
}

export function ServerSkipCooldownRolloutRequestFromJSON(
  json: any,
): ServerSkipCooldownRolloutRequest {
  return ServerSkipCooldownRolloutRequestFromJSONTyped(json, false);
}

export function ServerSkipCooldownRolloutRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServerSkipCooldownRolloutRequest {
  if (json == null) {
    return json;
  }
  return {
    step: json['step'] == null ? undefined : json['step'],
  };
}

export function ServerSkipCooldownRolloutRequestToJSON(
  json: any,
): ServerSkipCooldownRolloutRequest {
  return ServerSkipCooldownRolloutRequestToJSONTyped(json, false);
}

export function ServerSkipCooldownRolloutRequestToJSONTyped(
  value?: ServerSkipCooldownRolloutRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    step: value['step'],
  };
}
